
<i :class="selector"></i>
